/* src/app/default-location-modal/default-location-modal.component.scss */
.wc-form-control {
  border-radius: 3px;
  margin-bottom: 24px;
}
/*# sourceMappingURL=default-location-modal.component-PVDOFQZK.css.map */
